module.exports = __webpack_public_path__ + "static/media/PavementEdge.af9f7ed5.svg";